module.exports = __webpack_public_path__ + "static/media/4.b06fc33e.jpg";